/**
 * Peça visual dos avisos — a lógica (fila, duração, `useToast()`) mora em
 * `hooks/useToast.tsx`, que renderiza este viewport uma única vez, no topo do app.
 */
import type { ToastType } from '@/hooks/useToast';

export interface ToastViewportItem {
  id: number;
  message: string;
  type: ToastType;
}

export interface ToastViewportProps {
  toasts: ToastViewportItem[];
  onDismiss: (id: number) => void;
}

export function ToastViewport({ toasts, onDismiss }: ToastViewportProps) {
  return (
    <div className="toast-region" role="status" aria-live="polite" aria-atomic="false">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast-${t.type}`}>
          <div className="toast__body">{t.message}</div>
          <button
            type="button"
            className="toast__close"
            aria-label="Fechar aviso"
            onClick={() => onDismiss(t.id)}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
